import { render } from "./BaseInputPhone.vue?vue&type=template&id=acd4d89c&scoped=true&ts=true&lang=pug"
import script from "./BaseInputPhone.vue?vue&type=script&lang=ts"
export * from "./BaseInputPhone.vue?vue&type=script&lang=ts"

import "./BaseInputPhone.vue?vue&type=style&index=0&id=acd4d89c&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./BaseInputPhone.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/components/base/baseInputPhone.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2Fbase%2FBaseInputPhone.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acd4d89c"]])

export default __exports__